import Vue from "vue"
import VueRouter from 'vue-router'
import store  from '@/store'
import { common } from './common.js'
import {navs} from './nav.js'

Vue.use(VueRouter)
const createRouter = () => new VueRouter({
	routes:[...navs,...common]
})
const Router = createRouter()

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
	return VueRouterPush.call(this, to).catch(err => err)
}


export default Router